import React from 'react';
import PropTypes from 'prop-types';

// Icons
import { ReactComponent as CloseIcon } from '../../../assets/icons/cross.svg';

import styles from './BurgerMenu.module.scss';
import cn from '../../../utils/tools/cn';

function BurgerMenu({ children, isOpened, onClose }) {
  return (
    <div className={cn(['d-flex d-col', styles.burger_menu, isOpened ? styles.opened : ''])}>
      <button type="button" onClick={onClose} className={cn([styles.close_btn, 'd-flex a-center j-center'])}>
        <CloseIcon width={28} height={28} />
      </button>

      {children}
    </div>
  );
}

BurgerMenu.propTypes = {
  children: PropTypes.node.isRequired,
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
};

BurgerMenu.defaultProps = {
  isOpened: false,
  onClose: () => {},
};

export default BurgerMenu;
